import type { ReactNode } from 'react';

export const symbol_kettle: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M250-260v-473l-74-99q-11-15-2.81-31.5T200-880h453q27.85 0 47.43 19.57Q720-840.85 720-813v63h100q24.75 0 42.38 17.62Q880-714.75 880-690v220q0 24.75-17.62 42.37Q844.75-410 820-410H720v150q0 24.75-17.62 42.37Q684.75-200 660-200H310q-24.75 0-42.37-17.63Q250-235.25 250-260Zm60 0h350v-560H260l50 65v495Zm410-210h100v-220H720v220ZM514.5-745.42Q500-730.83 500-710v340q0 20.83 14.62 35.42Q529.24-320 550.12-320q20.88 0 35.38-14.58Q600-349.17 600-370v-340q0-20.83-14.62-35.42Q570.76-760 549.88-760q-20.88 0-35.38 14.58ZM150-80q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h660q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q822.75-80 810-80H150Zm310-460Z"
		/>
	</svg>
);
